import { PhilatelicItemType } from "@briefmarken_katalog/types";
import { translate } from "$lib/i18n";
import type { TranslationKey } from "$lib/i18n";

const allTypeLabels = [
  'original_edition',
  'reprint',
  'exists_with_imprint_jp5',
] as const;

export type LabelKey = typeof allTypeLabels[number];

function labelTranslationKey(key: LabelKey): TranslationKey {
  return `labels.${key}` as TranslationKey;
}

export function getLabelsForType(_type: PhilatelicItemType): LabelKey[] {
  return [...allTypeLabels].sort((a, b) =>
    translate(labelTranslationKey(a)).localeCompare(translate(labelTranslationKey(b)))
  );
}

export function translateLabel(key: string): string {
  return translate(`labels.${key}` as TranslationKey);
}
